import { useState } from "react";
import CheckboxField from "../../../../../components/Form/CheckboxField";
import { btn } from "../../../../../components/Button/buttonStyles";

const SettingsEditForm = ({ client, onCancel, onSave }) => {
  const [form, setForm] = useState({
    is_active: client?.is_active || false,
    can_receive_notifications: client?.can_receive_notifications || false,
  });

  const handleChange = (e) => {
    const { name, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(form);
  };

  return (
    <div>
      <div className="mb-5">
        <h2 className="text-xl font-bold text-gray-900">Edit Settings</h2>
      </div>
    <form
      onSubmit={handleSubmit}
      className="bg-white shadow-sm border border-gray-100 rounded-lg p-5 space-y-4"
    >
      <CheckboxField
        label="Active"
        name="is_active"
        checked={form.is_active}
        onChange={handleChange}
      />

      <CheckboxField
        label="Receive Notifications"
        name="can_receive_notifications"
        checked={form.can_receive_notifications}
        onChange={handleChange}
      />

      <div className="flex gap-2 text-sm pt-2 border-t border-gray-100">
        <button
          type="submit"
          className={btn("primary", "sm")}
        >
          Save
        </button>
        <button
          type="button"
          onClick={onCancel}
          className={btn("secondary", "sm")}
        >
          Cancel
        </button>
      </div>
    </form>
    </div>
  );
};

export default SettingsEditForm;
